import { Decoration, DecorationSet } from 'prosemirror-view'
import { Plugin, PluginKey, TextSelection } from 'prosemirror-state'

const FakeSelectionPluginKey = new PluginKey('FakeSelection')
const IsFocusedMeta = 'FakeSelectionPlugin_isFocused'

// This plugin adds some decorations to show a selection even if the editor is
// not in focus.
export const FakeSelection = new Plugin({
  key: FakeSelectionPluginKey,
  state: {
    init: () => false,
    apply: (tr, pluginState) => {
      const isFocused = tr.getMeta(IsFocusedMeta) as boolean | undefined
      return isFocused ?? pluginState
    },
  },
  props: {
    decorations(this: Plugin, state) {
      const pluginState = FakeSelectionPluginKey.getState(state)
      if (pluginState || state.selection.empty || !(state.selection instanceof TextSelection)) {
        return DecorationSet.empty
      }
      return DecorationSet.create(state.doc, [
        Decoration.inline(state.selection.$from.pos, state.selection.$to.pos, { class: 'selectionMarker' }),
      ])
    },
    handleDOMEvents: {
      blur: (view) => {
        view.dispatch(view.state.tr.setMeta(IsFocusedMeta, false))
        return false
      },
      focus: (view) => {
        view.dispatch(view.state.tr.setMeta(IsFocusedMeta, true))
        return false
      },
    },
  },
})
